import { Mock } from '@mock/model';
import { homeSchema } from '@mock/schema/home';
// import { webserieSchema } from '@mock/schema/webserie';

export const mock: Mock[] = [
  // {
  //   // method: 'GET',
  //   url: 'slug?slug=/web-serie-les-agenceurs',
  //   schema: webserieSchema,
  //   // status: 404,
  // },
  {
    // method: 'GET',
    url: 'slug?slug=/mock-homepage',
    schema: homeSchema,
    // status: 404,
  },
];
